import Glightbox from 'glightbox';

const lightbox = Glightbox(
    {
        'href': 'https://www.youtube.com/watch?v=Ga6RYejo6Hk',
        'type': 'video',
        'source': 'youtube', //vimeo, youtube or local
        'width': 500,
    }
);